const homePage = require('./pages/homepage');
const preview = require('./includes/img-preview');
const header = require('./includes/header');
const listProjectPreview = require('./includes/list-project-preview');
const animations = require('./includes/animations');
const playVideo = require('./includes/video-with-btn-play');
const projects = require('./pages/projects');
const service = require('./pages/service');
const contact = require('./pages/contact');

$("document").ready(function () {
    //pages
    header();
    homePage();
    preview();
    listProjectPreview();
    animations();
    projects();
    service();
    contact();
    playVideo();
});

$(window).resize(function () {

})
